import { Text, TokenTextAppearance, TokenTextColor } from '@volkswagen-onehub/components-core';
import React from 'react';
import { transformNumberFormat } from 'src/feature-app/hooks';
import { InfoCuotaProps } from '.';
import { isCommercial } from 'src/bff/get-data-url';
import { getDataServiceConfig } from 'src/feature-app';

const transformedTinTae = (num: string) => {
  let finalNumber;

  if (num.toString().includes('.')) {
    const aux = num.toString().split('.');

    if (aux[1].length === 2) {
      finalNumber = `${aux[0]},${aux[1]}`;
    } else if (aux[1].length === 1) {
      finalNumber = `${aux[0]},${aux[1]}0`;
    } else {
      finalNumber = `${aux[0]},00`;
    }
  } else {
    finalNumber = `${num},00`;
  }

  return finalNumber;
};

const TinTae = (props: InfoCuotaProps) => {
  const { offer } = props;
  const transformedTin = transformedTinTae(offer.tin);
  const transformedTae = transformedTinTae(offer.tae);

  return (
    <>
      {offer.myWay.activo === 1 && offer.tin && offer.tae ? (
        <>
          <Text bold>
            <span style={{ borderBottom: '1px solid #000000' }}>{transformedTae}% TAE</span>
          </Text>{' '}
          | {transformedTin}% TIN{' '}
          {/*  <Text appearance={TokenTextAppearance.copy200}>
            <sup>*</sup>La oferta incluye seguros opcionales y financiados no incluidos como gastos en el cálculo de la TAE.
          </Text> */}
        </>
      ) : null}
      {offer.next === 1 && offer.tin && offer.tae ? (
        <Text appearance={TokenTextAppearance.copy200}>
          <Text bold>
            <span style={{ borderBottom: '1px solid #000000' }}>{transformedTinTae(offer.tae)}% TAE</span>
          </Text>{' '}
          | {transformedTinTae(offer.tin)}% TIN{' '}
        </Text>
      ) : null}
      {offer.myRenting ? (
        <Text appearance={TokenTextAppearance.copy200}>
          Mantenimiento, asistencia, servicio de seguro y servicio complementario de reparaciones.
        </Text>
      ) : null}
    </>
  );
};

export const InfoCuotaDetails = (props: InfoCuotaProps) => {
  const { offer } = props;
  const { myRenting, myWay } = offer;

  const isOcasion = (offer: any) => {
    return offer.financiacionText.includes('Ocasión');
  };

  //transform format offer quota

  const CuotaEntrada = (): React.ReactElement => {
    const transformedEntrada = transformNumberFormat(offer.cuotaEntrada);

    return (
      <>
        <Text bold>| {transformedEntrada}€</Text> de entrada{' '}
      </>
    );
  };

  const CuotaFinal = () => {
    const transformedFinal =
      offer.cuotaFinal && offer.cuotaFinal !== '0' ? transformNumberFormat(offer.cuotaFinal) : null;

    return <>{transformedFinal ? <>Cuota Final: {transformedFinal}€</> : null}</>;
  };

  const dataService = getDataServiceConfig();

  return (
    <>
      {!offer.precio &&
        <>
          <Text appearance={TokenTextAppearance.copy200}>
          {offer.plazos && (
            <>
              <Text bold>{offer.plazos} </Text>cuotas {offer.cuotaEntrada && <CuotaEntrada />}
            </>
          )}
          {isOcasion(offer) && (
            <Text appearance={TokenTextAppearance.copy200}>
              Descubre todos los {offer.carlineTitle} de ocasión que tenemos para ti y elige el que encaja contigo.
            </Text>
          )}
          {myRenting === 1 || myWay.activo === 1 ? (
            <Text appearance={TokenTextAppearance.copy200}>{offer.ivaIncluido === 1 ? '(IVA incluido)' : '(sin IVA)'}</Text>
          ) : null}
        </Text>
        {isCommercial(dataService) && myRenting === 1 && (
          <Text appearance={TokenTextAppearance.copy200}>
            Mantenimiento, asistencia, servicio de seguro y servicio complementario de reparaciones.
          </Text>
        )}
        {offer.tin && offer.tae ? (
          <Text appearance={TokenTextAppearance.copy200}>
            <TinTae offer={offer} />
          </Text>
        ) : null}
        {!isOcasion(offer) ? (
          <Text appearance={TokenTextAppearance.copy200}>
            <CuotaFinal />
          </Text>
        ) : null}
        </>
      }
    </>
  );
};
